import { render, staticRenderFns } from "./RecommendationBusinessForm.vue?vue&type=template&id=4e246120&scoped=true&"
import script from "./RecommendationBusinessForm.vue?vue&type=script&lang=js&"
export * from "./RecommendationBusinessForm.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationBusinessForm.vue?vue&type=style&index=0&id=4e246120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e246120",
  null
  
)

export default component.exports